module.exports = __webpack_public_path__ + "media/site_templates/www.cabinetmaker.company/images/about_us-c5d4cb31c45b94aa761ffb9208fcf72d.jpg";